import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state

const initialState = {
  applied_letter_data: [],
};

export const appliedLetterSlice = createSlice({
  name: "appliedLetter",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setAppliedLetter: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.applied_letter_data = payload;
    },
    resetAppliedLetter: (state: any, action: PayloadAction<any>) => {
      state.applied_letter_data = [];
    },
  },
});

export const { setAppliedLetter, resetAppliedLetter } =
  appliedLetterSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default appliedLetterSlice.reducer;
